// modules
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

// imports
import { Search } from './search.component';

@NgModule({
  declarations: [
    Search
  ],
  exports: [
    Search
  ],
  imports: [
    FormsModule,
    CommonModule,
    IconModule,
  ]
})
export class SearchModule { }

export { Search };
